import { AbstractControl, ValidationErrors } from '@angular/forms';

export class GlnValidator {
  static validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    const gln = control.value.toString().trim();
    if (!GlnValidator.isValid(gln)) {
      return { gln: { value: control.value } };
    }
    return null;
  }

  static isValid(gln: string): boolean {
    if (!gln || gln.length !== 13 || !/^\d{13}$/.test(gln)) {
      return false;
    }

    let sum = 0;
    for (let i = 0; i < 12; i++) {
      const digit = parseInt(gln[i], 10);
      sum += i % 2 === 0 ? digit : digit * 3;
    }
    const checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit === parseInt(gln[12], 10);
  }
}
